import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiChamili';
const args = {};

export class PetastiChamili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
